export default [
  { alternatives: 'happy, cheerful', category: 'people', name: 'smile' },
  { alternatives: 'lol, funny', category: 'people', name: 'laughing' },
  { alternatives: '', category: 'people', name: 'blush' },
  { alternatives: 'funny', category: 'people', name: 'smiley' },
  { alternatives: '', category: 'people', name: 'relaxed' },
  { alternatives: '', category: 'people', name: 'smirk' },
  { alternatives: 'love', category: 'people', name: 'heart_eyes' },
  { alternatives: 'kiss', category: 'people', name: 'kissing_heart' },
  { alternatives: '', category: 'people', name: 'kissing_closed_eyes' },
  { alternatives: 'flustered, embarassed', category: 'people', name: 'flushed' },
  { alternatives: '', category: 'people', name: 'relieved' },
  { alternatives: '', category: 'people', name: 'satisfied' },
  { alternatives: 'happy, smile', category: 'people', name: 'grin' },
  { alternatives: 'flirt', category: 'people', name: 'wink' },
  { alternatives: '', category: 'people', name: 'stuck_out_tongue_winking_eye' },
  { alternatives: '', category: 'people', name: 'stuck_out_tongue_closed_eyes' },
  { alternatives: 'smiling', category: 'people', name: 'grinning' },
  { alternatives: '', category: 'people', name: 'kissing' },
  { alternatives: 'smooch', category: 'people', name: 'kissing_smiling_eyes' },
  { alternatives: '', category: 'people', name: 'stuck_out_tongue' },
  { alternatives: 'asleep', category: 'people', name: 'sleeping' },
  { alternatives: 'frustrated, scared', category: 'people', name: 'worried' },
  { alternatives: '', category: 'people', name: 'frowning' },
  { alternatives: '', category: 'people', name: 'anguished' },
  { alternatives: '', category: 'people', name: 'open_mouth' },
  { alternatives: '', category: 'people', name: 'grimacing' },
  { alternatives: 'baffled, puzzled', category: 'people', name: 'confused' },
  { alternatives: '', category: 'people', name: 'hushed' },
  { alternatives: 'deadpan', category: 'people', name: 'expressionless' },
  { alternatives: 'sarcasm', category: 'people', name: 'unamused' },
  { alternatives: 'happy, relief', category: 'people', name: 'sweat_smile' },
  { alternatives: 'worried, stressed', category: 'people', name: 'sweat' },
  { alternatives: '', category: 'people', name: 'disappointed_relieved' },
  { alternatives: 'tired', category: 'people', name: 'weary' },
  { alternatives: '', category: 'people', name: 'pensive' },
  { alternatives: 'sad, lonely', category: 'people', name: 'disappointed' },
  { alternatives: '', category: 'people', name: 'confounded' },
  { alternatives: 'scared, afraid, nervous, scared', category: 'people', name: 'fearful' },
  { alternatives: 'scared, frightened, nervous, scared', category: 'people', name: 'cold_sweat' },
  { alternatives: '', category: 'people', name: 'persevere' },
  { alternatives: 'sad, unhappy, tear', category: 'people', name: 'cry' },
  { alternatives: 'sad, unhappy', category: 'people', name: 'sob' },
  { alternatives: 'happy, happytears', category: 'people', name: 'joy' },
  { alternatives: '', category: 'people', name: 'astonished' },
  { alternatives: 'halloween, scary, scared, terrified', category: 'people', name: 'scream' },
  { alternatives: '', category: 'people', name: 'tired_face' },
  { alternatives: '', category: 'people', name: 'angry' },
  { alternatives: 'furious', category: 'people', name: 'rage' },
  { alternatives: '', category: 'people', name: 'triumph' },
  { alternatives: 'tired, zzz', category: 'people', name: 'sleepy' },
  { alternatives: 'delicious', category: 'people', name: 'yum' },
  { alternatives: '', category: 'people', name: 'mask' },
  { alternatives: 'shades', category: 'people', name: 'sunglasses' },
  { alternatives: 'ko', category: 'people', name: 'dizzy_face' },
  { alternatives: '', category: 'people', name: 'imp' },
  { alternatives: '', category: 'people', name: 'smiling_imp' },
  { alternatives: '', category: 'people', name: 'neutral_face' },
  { alternatives: '', category: 'people', name: 'no_mouth' },
  { alternatives: 'angel', category: 'people', name: 'innocent' },
  { alternatives: 'extraterrestrial', category: 'people', name: 'alien' },
  { alternatives: '', category: 'people', name: 'yellow_heart' },
  { alternatives: '', category: 'people', name: 'blue_heart' },
  { alternatives: '', category: 'people', name: 'purple_heart' },
  { alternatives: '', category: 'people', name: 'heart' },
  { alternatives: '', category: 'people', name: 'green_heart' },
  { alternatives: 'heartbreak', category: 'people', name: 'broken_heart' },
  { alternatives: '', category: 'people', name: 'heartbeat' },
  { alternatives: '', category: 'people', name: 'heartpulse' },
  { alternatives: '', category: 'people', name: 'two_hearts' },
  { alternatives: '', category: 'people', name: 'revolving_hearts' },
  { alternatives: '', category: 'people', name: 'cupid' },
  { alternatives: '', category: 'people', name: 'sparkling_heart' },
  { alternatives: '', category: 'people', name: 'sparkles' },
  { alternatives: '', category: 'people', name: 'star' },
  { alternatives: '', category: 'people', name: 'star2' },
  { alternatives: '', category: 'people', name: 'dizzy' },
  { alternatives: 'explosion', category: 'people', name: 'boom' },
  { alternatives: '', category: 'people', name: 'collision' },
  { alternatives: 'angry, mad', category: 'people', name: 'anger' },
  { alternatives: '', category: 'people', name: 'exclamation' },
  { alternatives: '', category: 'people', name: 'question' },
  { alternatives: '', category: 'people', name: 'grey_exclamation' },
  { alternatives: '', category: 'people', name: 'grey_question' },
  { alternatives: 'sleep, bored', category: 'people', name: 'zzz' },
  { alternatives: '', category: 'people', name: 'dash' },
  { alternatives: 'water', category: 'people', name: 'sweat_drops' },
  { alternatives: 'music', category: 'people', name: 'notes' },
  { alternatives: 'music', category: 'people', name: 'musical_note' },
  { alternatives: '', category: 'people', name: 'fire' },
  { alternatives: 'shit, turd', category: 'people', name: 'poop' },
  { alternatives: 'thumbsup like', category: 'people', name: '+1' },
  { alternatives: 'dislike thumbsdown', category: 'people', name: '-1' },
  { alternatives: '', category: 'people', name: 'ok_hand' },
  { alternatives: 'pound facepunch', category: 'people', name: 'punch' },
  { alternatives: '', category: 'people', name: 'fist' },
  { alternatives: 'peace, deuces', category: 'people', name: 'v' },
  { alternatives: 'hi, hello, bye', category: 'people', name: 'wave' },
  { alternatives: 'stop raised_hand', category: 'people', name: 'hand' },
  { alternatives: '', category: 'people', name: 'open_hands' },
  { alternatives: '', category: 'people', name: 'point_up' },
  { alternatives: '', category: 'people', name: 'point_down' },
  { alternatives: '', category: 'people', name: 'point_left' },
  { alternatives: '', category: 'people', name: 'point_right' },
  { alternatives: '', category: 'people', name: 'raised_hands' },
  { alternatives: '', category: 'people', name: 'pray' },
  { alternatives: '', category: 'people', name: 'point_up_2' },
  { alternatives: '', category: 'people', name: 'clap' },
  { alternatives: '', category: 'people', name: 'muscle' },
  { alternatives: 'sport', category: 'people', name: 'runner' },
  { alternatives: 'sport', category: 'people', name: 'running' },
  { alternatives: '', category: 'people', name: 'couple' },
  { alternatives: '', category: 'people', name: 'family' },
  { alternatives: 'gay', category: 'people', name: 'two_men_holding_hands' },
  { alternatives: 'gay', category: 'people', name: 'two_women_holding_hands' },
  { alternatives: 'party', category: 'people', name: 'dancer' },
  { alternatives: 'party', category: 'people', name: 'dancers' },
  { alternatives: '', category: 'people', name: 'ok_woman' },
  { alternatives: '', category: 'people', name: 'no_good' },
  { alternatives: '', category: 'people', name: 'information_desk_person' },
  { alternatives: '', category: 'people', name: 'raising_hand' },
  { alternatives: '', category: 'people', name: 'bride_with_veil' },
  { alternatives: '', category: 'people', name: 'person_with_pouting_face' },
  { alternatives: '', category: 'people', name: 'person_frowning' },
  { alternatives: '', category: 'people', name: 'bow' },
  { alternatives: '', category: 'people', name: 'couplekiss' },
  { alternatives: '', category: 'people', name: 'couple_with_heart' },
  { alternatives: '', category: 'people', name: 'massage' },
  { alternatives: '', category: 'people', name: 'haircut' },
  { alternatives: 'manicure', category: 'people', name: 'nail_care' },
  { alternatives: '', category: 'people', name: 'boy' },
  { alternatives: 'female', category: 'people', name: 'girl' },
  { alternatives: 'female', category: 'people', name: 'woman' },
  { alternatives: 'guy', category: 'people', name: 'man' },
  { alternatives: 'infant, child', category: 'people', name: 'baby' },
  { alternatives: 'grandma, granny', category: 'people', name: 'older_woman' },
  { alternatives: 'grandpa, grandad', category: 'people', name: 'older_man' },
  { alternatives: '', category: 'people', name: 'person_with_blond_hair' },
  { alternatives: '', category: 'people', name: 'man_with_gua_pi_mao' },
  { alternatives: '', category: 'people', name: 'man_with_turban' },
  { alternatives: '', category: 'people', name: 'construction_worker' },
  { alternatives: 'police, policeman', category: 'people', name: 'cop' },
  { alternatives: '', category: 'people', name: 'angel' },
  { alternatives: '', category: 'people', name: 'princess' },
  { alternatives: 'animal, happy', category: 'people', name: 'smiley_cat' },
  { alternatives: 'animal, happy', category: 'people', name: 'smile_cat' },
  { alternatives: 'animal, love', category: 'people', name: 'heart_eyes_cat' },
  { alternatives: 'animal, love', category: 'people', name: 'kissing_cat' },
  { alternatives: 'animal', category: 'people', name: 'smirk_cat' },
  { alternatives: 'animal', category: 'people', name: 'scream_cat' },
  { alternatives: 'animal, sad', category: 'people', name: 'crying_cat_face' },
  { alternatives: 'animal, happy', category: 'people', name: 'joy_cat' },
  { alternatives: 'animal, sad, unhappy, angry', category: 'people', name: 'pouting_cat' },
  { alternatives: 'namahage', category: 'people', name: 'japanese_ogre' },
  { alternatives: 'tengu', category: 'people', name: 'japanese_goblin' },
  { alternatives: '', category: 'people', name: 'see_no_evil' },
  { alternatives: '', category: 'people', name: 'hear_no_evil' },
  { alternatives: '', category: 'people', name: 'speak_no_evil' },
  { alternatives: '', category: 'people', name: 'guardsman' },
  { alternatives: 'scary, halloween', category: 'people', name: 'skull' },
  { alternatives: '', category: 'people', name: 'feet' },
  { alternatives: '', category: 'people', name: 'lips' },
  { alternatives: '', category: 'people', name: 'kiss' },
  { alternatives: 'water', category: 'people', name: 'droplet' },
  { alternatives: '', category: 'people', name: 'ear' },
  { alternatives: 'eye-rolling', category: 'people', name: 'eyes' },
  { alternatives: '', category: 'people', name: 'nose' },
  { alternatives: '', category: 'people', name: 'tongue' },
  { alternatives: '', category: 'people', name: 'love_letter' },
  { alternatives: '', category: 'people', name: 'bust_in_silhouette' },
  { alternatives: '', category: 'people', name: 'busts_in_silhouette' },
  { alternatives: '', category: 'people', name: 'speech_balloon' },
  { alternatives: '', category: 'people', name: 'thought_balloon' },

  { alternatives: 'weather, sun', category: 'nature', name: 'sunny' },
  { alternatives: 'water, rain', category: 'nature', name: 'umbrella' },
  { alternatives: '', category: 'nature', name: 'cloud' },
  { alternatives: '', category: 'nature', name: 'snowflake' },
  { alternatives: '', category: 'nature', name: 'snowman' },
  { alternatives: 'weather, lightning', category: 'nature', name: 'zap' },
  { alternatives: 'weather', category: 'nature', name: 'cyclone' },
  { alternatives: 'weather, fog', category: 'nature', name: 'foggy' },
  { alternatives: 'waves', category: 'nature', name: 'ocean' },
  { alternatives: 'animal', category: 'nature', name: 'cat' },
  { alternatives: 'animal', category: 'nature', name: 'dog' },
  { alternatives: 'animal', category: 'nature', name: 'mouse' },
  { alternatives: 'animal', category: 'nature', name: 'hamster' },
  { alternatives: 'animal', category: 'nature', name: 'rabbit' },
  { alternatives: 'animal,dog', category: 'nature', name: 'wolf' },
  { alternatives: 'animal', category: 'nature', name: 'frog' },
  { alternatives: 'animal', category: 'nature', name: 'tiger' },
  { alternatives: 'animal', category: 'nature', name: 'koala' },
  { alternatives: 'animal', category: 'nature', name: 'bear' },
  { alternatives: 'animal', category: 'nature', name: 'pig' },
  { alternatives: 'animal', category: 'nature', name: 'pig_nose' },
  { alternatives: 'animal', category: 'nature', name: 'cow' },
  { alternatives: 'animal', category: 'nature', name: 'boar' },
  { alternatives: 'animal', category: 'nature', name: 'monkey_face' },
  { alternatives: 'animal', category: 'nature', name: 'monkey' },
  { alternatives: 'animal', category: 'nature', name: 'horse' },
  { alternatives: 'animal', category: 'nature', name: 'racehorse' },
  { alternatives: 'animal', category: 'nature', name: 'camel' },
  { alternatives: 'animal', category: 'nature', name: 'sheep' },
  { alternatives: 'animal', category: 'nature', name: 'elephant' },
  { alternatives: 'animal', category: 'nature', name: 'panda_face' },
  { alternatives: 'animal,serpent', category: 'nature', name: 'snake' },
  { alternatives: 'animal', category: 'nature', name: 'bird' },
  { alternatives: 'animal, bird', category: 'nature', name: 'baby_chick' },
  { alternatives: 'animal, bird', category: 'nature', name: 'hatched_chick' },
  { alternatives: 'animal, bird,egg', category: 'nature', name: 'hatching_chick' },
  { alternatives: 'animal, bird', category: 'nature', name: 'chicken' },
  { alternatives: 'animal, bird', category: 'nature', name: 'penguin' },
  { alternatives: 'animal, tortoise', category: 'nature', name: 'turtle' },
  { alternatives: 'animal', category: 'nature', name: 'bug' },
  { alternatives: 'animal', category: 'nature', name: 'honeybee' },
  { alternatives: 'animal', category: 'nature', name: 'ant' },
  { alternatives: 'animal', category: 'nature', name: 'beetle' },
  { alternatives: 'animal', category: 'nature', name: 'snail' },
  { alternatives: 'animal', category: 'nature', name: 'octopus' },
  { alternatives: 'animal', category: 'nature', name: 'tropical_fish' },
  { alternatives: 'animal', category: 'nature', name: 'fish' },
  { alternatives: 'animal', category: 'nature', name: 'whale' },
  { alternatives: 'animal', category: 'nature', name: 'whale2' },
  { alternatives: 'animal', category: 'nature', name: 'dolphin' },
  { alternatives: 'animal', category: 'nature', name: 'cow2' },
  { alternatives: 'animal', category: 'nature', name: 'ram' },
  { alternatives: 'animal', category: 'nature', name: 'rat' },
  { alternatives: 'animal', category: 'nature', name: 'water_buffalo' },
  { alternatives: 'animal', category: 'nature', name: 'tiger2' },
  { alternatives: 'animal, bunny', category: 'nature', name: 'rabbit2' },
  { alternatives: 'animal', category: 'nature', name: 'dragon' },
  { alternatives: 'animal', category: 'nature', name: 'goat' },
  { alternatives: 'animal, chicken', category: 'nature', name: 'rooster' },
  { alternatives: 'animal', category: 'nature', name: 'dog2' },
  { alternatives: 'animal', category: 'nature', name: 'pig2' },
  { alternatives: 'animal', category: 'nature', name: 'mouse2' },
  { alternatives: 'animal', category: 'nature', name: 'ox' },
  { alternatives: 'animal', category: 'nature', name: 'dragon_face' },
  { alternatives: 'animal', category: 'nature', name: 'blowfish' },
  { alternatives: 'animal, alligator', category: 'nature', name: 'crocodile' },
  { alternatives: 'animal', category: 'nature', name: 'dromedary_camel' },
  { alternatives: 'animal', category: 'nature', name: 'leopard' },
  { alternatives: 'animal, kitty, kitten', category: 'nature', name: 'cat2' },
  { alternatives: 'animal, dog', category: 'nature', name: 'poodle' },
  { alternatives: 'animal', category: 'nature', name: 'paw_prints' },
  { alternatives: '', category: 'nature', name: 'bouquet' },
  { alternatives: 'floral', category: 'nature', name: 'cherry_blossom' },
  { alternatives: 'floral', category: 'nature', name: 'tulip' },
  { alternatives: '', category: 'nature', name: 'four_leaf_clover' },
  { alternatives: 'floral', category: 'nature', name: 'rose' },
  { alternatives: 'floral', category: 'nature', name: 'sunflower' },
  { alternatives: 'floral', category: 'nature', name: 'hibiscus' },
  { alternatives: '', category: 'nature', name: 'maple_leaf' },
  { alternatives: '', category: 'nature', name: 'leaves' },
  { alternatives: '', category: 'nature', name: 'fallen_leaf' },
  { alternatives: '', category: 'nature', name: 'herb' },
  { alternatives: '', category: 'nature', name: 'mushroom' },
  { alternatives: '', category: 'nature', name: 'cactus' },
  { alternatives: '', category: 'nature', name: 'palm_tree' },
  { alternatives: '', category: 'nature', name: 'evergreen_tree' },
  { alternatives: '', category: 'nature', name: 'deciduous_tree' },
  { alternatives: '', category: 'nature', name: 'chestnut' },
  { alternatives: '', category: 'nature', name: 'seedling' },
  { alternatives: '', category: 'nature', name: 'blossom' },
  { alternatives: '', category: 'nature', name: 'ear_of_rice' },
  { alternatives: '', category: 'nature', name: 'shell' },
  { alternatives: '', category: 'nature', name: 'globe_with_meridians' },
  { alternatives: '', category: 'nature', name: 'sun_with_face' },
  { alternatives: '', category: 'nature', name: 'full_moon_with_face' },
  { alternatives: '', category: 'nature', name: 'new_moon_with_face' },
  { alternatives: '', category: 'nature', name: 'new_moon' },
  { alternatives: '', category: 'nature', name: 'waxing_crescent_moon' },
  { alternatives: '', category: 'nature', name: 'first_quarter_moon' },
  { alternatives: '', category: 'nature', name: 'waxing_gibbous_moon' },
  { alternatives: '', category: 'nature', name: 'full_moon' },
  { alternatives: '', category: 'nature', name: 'waning_gibbous_moon' },
  { alternatives: '', category: 'nature', name: 'last_quarter_moon' },
  { alternatives: '', category: 'nature', name: 'waning_crescent_moon' },
  { alternatives: '', category: 'nature', name: 'last_quarter_moon_with_face' },
  { alternatives: '', category: 'nature', name: 'first_quarter_moon_with_face' },
  { alternatives: '', category: 'nature', name: 'crescent_moon' },
  { alternatives: 'europe, emea', category: 'nature', name: 'earth_africa' },
  { alternatives: '', category: 'nature', name: 'earth_americas' },
  { alternatives: '', category: 'nature', name: 'earth_asia' },
  { alternatives: '', category: 'nature', name: 'volcano' },
  { alternatives: '', category: 'nature', name: 'milky_way' },
  { alternatives: 'weather', category: 'nature', name: 'partly_sunny' },

  { alternatives: '', category: 'objects', name: 'bamboo' },
  { alternatives: '', category: 'objects', name: 'gift_heart' },
  { alternatives: '', category: 'objects', name: 'dolls' },
  { alternatives: '', category: 'objects', name: 'school_satchel' },
  { alternatives: 'education, university, graduation, hat', category: 'objects', name: 'mortar_board' },
  { alternatives: '', category: 'objects', name: 'flags' },
  { alternatives: '', category: 'objects', name: 'fireworks' },
  { alternatives: '', category: 'objects', name: 'sparkler' },
  { alternatives: '', category: 'objects', name: 'wind_chime' },
  { alternatives: '', category: 'objects', name: 'rice_scene' },
  { alternatives: 'halloween', category: 'objects', name: 'jack_o_lantern' },
  { alternatives: 'boom, halloween', category: 'objects', name: 'ghost' },
  { alternatives: 'christmas', category: 'objects', name: 'santa' },
  { alternatives: '', category: 'objects', name: 'christmas_tree' },
  { alternatives: 'present', category: 'objects', name: 'gift' },
  { alternatives: '', category: 'objects', name: 'bell' },
  { alternatives: '', category: 'objects', name: 'no_bell' },
  { alternatives: '', category: 'objects', name: 'tanabata_tree' },
  { alternatives: '', category: 'objects', name: 'tada' },
  { alternatives: 'celebration', category: 'objects', name: 'confetti_ball' },
  { alternatives: '', category: 'objects', name: 'balloon' },
  { alternatives: '', category: 'objects', name: 'crystal_ball' },
  { alternatives: '', category: 'objects', name: 'cd' },
  { alternatives: '', category: 'objects', name: 'dvd' },
  { alternatives: '', category: 'objects', name: 'floppy_disk' },
  { alternatives: '', category: 'objects', name: 'camera' },
  { alternatives: '', category: 'objects', name: 'video_camera' },
  { alternatives: '', category: 'objects', name: 'movie_camera' },
  { alternatives: '', category: 'objects', name: 'computer' },
  { alternatives: 'television', category: 'objects', name: 'tv' },
  { alternatives: '', category: 'objects', name: 'iphone' },
  { alternatives: '', category: 'objects', name: 'phone' },
  { alternatives: '', category: 'objects', name: 'telephone' },
  { alternatives: '', category: 'objects', name: 'telephone_receiver' },
  { alternatives: '', category: 'objects', name: 'pager' },
  { alternatives: '', category: 'objects', name: 'fax' },
  { alternatives: '', category: 'objects', name: 'minidisc' },
  { alternatives: '', category: 'objects', name: 'vhs' },
  { alternatives: 'loud, noise', category: 'objects', name: 'sound' },
  { alternatives: '', category: 'objects', name: 'speaker' },
  { alternatives: '', category: 'objects', name: 'mute' },
  { alternatives: '', category: 'objects', name: 'loudspeaker' },
  { alternatives: '', category: 'objects', name: 'mega' },
  { alternatives: '', category: 'objects', name: 'hourglass' },
  { alternatives: '', category: 'objects', name: 'hourglass_flowing_sand' },
  { alternatives: '', category: 'objects', name: 'alarm_clock' },
  { alternatives: 'clock', category: 'objects', name: 'watch' },
  { alternatives: '', category: 'objects', name: 'radio' },
  { alternatives: '', category: 'objects', name: 'satellite' },
  { alternatives: '', category: 'objects', name: 'loop' },
  { alternatives: 'magnifying, glass', category: 'objects', name: 'mag' },
  { alternatives: 'magnifying, glass', category: 'objects', name: 'mag_right' },
  { alternatives: '', category: 'objects', name: 'unlock' },
  { alternatives: '', category: 'objects', name: 'lock' },
  { alternatives: '', category: 'objects', name: 'lock_with_ink_pen' },
  { alternatives: '', category: 'objects', name: 'closed_lock_with_key' },
  { alternatives: '', category: 'objects', name: 'key' },
  { alternatives: 'light', category: 'objects', name: 'bulb' },
  { alternatives: '', category: 'objects', name: 'flashlight' },
  { alternatives: '', category: 'objects', name: 'high_brightness' },
  { alternatives: '', category: 'objects', name: 'low_brightness' },
  { alternatives: '', category: 'objects', name: 'electric_plug' },
  { alternatives: 'power', category: 'objects', name: 'battery' },
  { alternatives: '', category: 'objects', name: 'calling' },
  { alternatives: '', category: 'objects', name: 'email' },
  { alternatives: '', category: 'objects', name: 'mailbox' },
  { alternatives: '', category: 'objects', name: 'postbox' },
  { alternatives: '', category: 'objects', name: 'bath' },
  { alternatives: '', category: 'objects', name: 'bathtub' },
  { alternatives: 'water', category: 'objects', name: 'shower' },
  { alternatives: '', category: 'objects', name: 'toilet' },
  { alternatives: 'tools', category: 'objects', name: 'wrench' },
  { alternatives: 'tools', category: 'objects', name: 'nut_and_bolt' },
  { alternatives: 'tools', category: 'objects', name: 'hammer' },
  { alternatives: '', category: 'objects', name: 'seat' },
  { alternatives: '', category: 'objects', name: 'moneybag' },
  { alternatives: 'bill cash currency money', category: 'objects', name: 'yen' },
  { alternatives: 'bill cash currency money', category: 'objects', name: 'dollar' },
  { alternatives: 'bill cash currency money', category: 'objects', name: 'pound' },
  { alternatives: 'bill cash currency money', category: 'objects', name: 'euro' },
  { alternatives: 'money', category: 'objects', name: 'credit_card' },
  { alternatives: 'money', category: 'objects', name: 'money_with_wings' },
  { alternatives: 'mail, send', category: 'objects', name: 'e-mail' },
  { alternatives: '', category: 'objects', name: 'inbox_tray' },
  { alternatives: '', category: 'objects', name: 'outbox_tray' },
  { alternatives: '', category: 'objects', name: 'envelope' },
  { alternatives: '', category: 'objects', name: 'incoming_envelope' },
  { alternatives: '', category: 'objects', name: 'postal_horn' },
  { alternatives: '', category: 'objects', name: 'mailbox_closed' },
  { alternatives: '', category: 'objects', name: 'mailbox_with_mail' },
  { alternatives: '', category: 'objects', name: 'mailbox_with_no_mail' },
  { alternatives: 'box', category: 'objects', name: 'package' },
  { alternatives: '', category: 'objects', name: 'door' },
  { alternatives: 'smoke', category: 'objects', name: 'smoking' },
  { alternatives: '', category: 'objects', name: 'bomb' },
  { alternatives: '', category: 'objects', name: 'gun' },
  { alternatives: '', category: 'objects', name: 'hocho' },
  { alternatives: '', category: 'objects', name: 'pill' },
  { alternatives: '', category: 'objects', name: 'syringe' },
  { alternatives: '', category: 'objects', name: 'page_facing_up' },
  { alternatives: '', category: 'objects', name: 'page_with_curl' },
  { alternatives: '', category: 'objects', name: 'bookmark_tabs' },
  { alternatives: '', category: 'objects', name: 'bar_chart' },
  { alternatives: '', category: 'objects', name: 'chart_with_upwards_trend' },
  { alternatives: '', category: 'objects', name: 'chart_with_downwards_trend' },
  { alternatives: '', category: 'objects', name: 'scroll' },
  { alternatives: '', category: 'objects', name: 'clipboard' },
  { alternatives: '', category: 'objects', name: 'calendar' },
  { alternatives: 'calendar', category: 'objects', name: 'date' },
  { alternatives: '', category: 'objects', name: 'card_index' },
  { alternatives: '', category: 'objects', name: 'file_folder' },
  { alternatives: '', category: 'objects', name: 'open_file_folder' },
  { alternatives: '', category: 'objects', name: 'scissors' },
  { alternatives: '', category: 'objects', name: 'pushpin' },
  { alternatives: '', category: 'objects', name: 'paperclip' },
  { alternatives: '', category: 'objects', name: 'black_nib' },
  { alternatives: '', category: 'objects', name: 'pencil2' },
  { alternatives: '', category: 'objects', name: 'straight_ruler' },
  { alternatives: '', category: 'objects', name: 'triangular_ruler' },
  { alternatives: '', category: 'objects', name: 'closed_book' },
  { alternatives: '', category: 'objects', name: 'green_book' },
  { alternatives: '', category: 'objects', name: 'blue_book' },
  { alternatives: '', category: 'objects', name: 'orange_book' },
  { alternatives: '', category: 'objects', name: 'notebook' },
  { alternatives: '', category: 'objects', name: 'notebook_with_decorative_cover' },
  { alternatives: '', category: 'objects', name: 'ledger' },
  { alternatives: '', category: 'objects', name: 'books' },
  { alternatives: '', category: 'objects', name: 'bookmark' },
  { alternatives: '', category: 'objects', name: 'name_badge' },
  { alternatives: '', category: 'objects', name: 'microscope' },
  { alternatives: '', category: 'objects', name: 'telescope' },
  { alternatives: '', category: 'objects', name: 'newspaper' },
  { alternatives: 'sport', category: 'objects', name: 'football' },
  { alternatives: 'sport', category: 'objects', name: 'basketball' },
  { alternatives: 'sport', category: 'objects', name: 'soccer' },
  { alternatives: 'sport', category: 'objects', name: 'baseball' },
  { alternatives: 'sport', category: 'objects', name: 'tennis' },
  { alternatives: 'magic_ball', category: 'objects', name: '8ball' },
  { alternatives: 'sport', category: 'objects', name: 'rugby_football' },
  { alternatives: 'sport', category: 'objects', name: 'bowling' },
  { alternatives: 'sport', category: 'objects', name: 'golf' },
  { alternatives: 'sport, vehicle', category: 'objects', name: 'mountain_bicyclist' },
  { alternatives: 'sport, vehicle', category: 'objects', name: 'bicyclist' },
  { alternatives: 'sport', category: 'objects', name: 'horse_racing' },
  { alternatives: 'sport', category: 'objects', name: 'snowboarder' },
  { alternatives: 'sport', category: 'objects', name: 'swimmer' },
  { alternatives: 'sport', category: 'objects', name: 'surfer' },
  { alternatives: 'sport', category: 'objects', name: 'ski' },
  { alternatives: 'cards, suit', category: 'objects', name: 'spades' },
  { alternatives: 'cards, suit', category: 'objects', name: 'hearts' },
  { alternatives: 'cards, suit', category: 'objects', name: 'clubs' },
  { alternatives: 'cards, suit', category: 'objects', name: 'diamonds' },
  { alternatives: 'jewelery', category: 'objects', name: 'gem' },
  { alternatives: 'jewelery', category: 'objects', name: 'ring' },
  { alternatives: '', category: 'objects', name: 'trophy' },
  { alternatives: '', category: 'objects', name: 'musical_score' },
  { alternatives: '', category: 'objects', name: 'musical_keyboard' },
  { alternatives: '', category: 'objects', name: 'violin' },
  { alternatives: '', category: 'objects', name: 'space_invader' },
  { alternatives: 'controller', category: 'objects', name: 'video_game' },
  { alternatives: '', category: 'objects', name: 'black_joker' },
  { alternatives: 'floral', category: 'objects', name: 'flower_playing_cards' },
  { alternatives: '', category: 'objects', name: 'game_die' },
  { alternatives: '', category: 'objects', name: 'dart' },
  { alternatives: '', category: 'objects', name: 'mahjong' },
  { alternatives: '', category: 'objects', name: 'clapper' },
  { alternatives: '', category: 'objects', name: 'memo' },
  { alternatives: '', category: 'objects', name: 'pencil' },
  { alternatives: '', category: 'objects', name: 'book' },
  { alternatives: '', category: 'objects', name: 'art' },
  { alternatives: '', category: 'objects', name: 'microphone' },
  { alternatives: '', category: 'objects', name: 'headphones' },
  { alternatives: '', category: 'objects', name: 'trumpet' },
  { alternatives: '', category: 'objects', name: 'saxophone' },
  { alternatives: '', category: 'objects', name: 'guitar' },
  { alternatives: '', category: 'objects', name: 'shoe' },
  { alternatives: '', category: 'objects', name: 'sandal' },
  { alternatives: '', category: 'objects', name: 'high_heel' },
  { alternatives: '', category: 'objects', name: 'lipstick' },
  { alternatives: '', category: 'objects', name: 'boot' },
  { alternatives: '', category: 'objects', name: 'shirt' },
  { alternatives: '', category: 'objects', name: 'tshirt' },
  { alternatives: '', category: 'objects', name: 'necktie' },
  { alternatives: '', category: 'objects', name: 'womans_clothes' },
  { alternatives: '', category: 'objects', name: 'dress' },
  { alternatives: '', category: 'objects', name: 'running_shirt_with_sash' },
  { alternatives: '', category: 'objects', name: 'jeans' },
  { alternatives: '', category: 'objects', name: 'kimono' },
  { alternatives: '', category: 'objects', name: 'bikini' },
  { alternatives: '', category: 'objects', name: 'ribbon' },
  { alternatives: '', category: 'objects', name: 'tophat' },
  { alternatives: '', category: 'objects', name: 'crown' },
  { alternatives: '', category: 'objects', name: 'womans_hat' },
  { alternatives: '', category: 'objects', name: 'mans_shoe' },
  { alternatives: '', category: 'objects', name: 'closed_umbrella' },
  { alternatives: '', category: 'objects', name: 'briefcase' },
  { alternatives: '', category: 'objects', name: 'handbag' },
  { alternatives: '', category: 'objects', name: 'pouch' },
  { alternatives: 'pocketbook', category: 'objects', name: 'purse' },
  { alternatives: '', category: 'objects', name: 'eyeglasses' },
  { alternatives: '', category: 'objects', name: 'fishing_pole_and_fish' },
  { alternatives: '', category: 'objects', name: 'coffee' },
  { alternatives: '', category: 'objects', name: 'tea' },
  { alternatives: 'drink alcohol', category: 'objects', name: 'sake' },
  { alternatives: '', category: 'objects', name: 'baby_bottle' },
  { alternatives: 'drink alcohol', category: 'objects', name: 'beer' },
  { alternatives: 'drink alcohol', category: 'objects', name: 'beers' },
  { alternatives: 'drink alcohol', category: 'objects', name: 'cocktail' },
  { alternatives: '', category: 'objects', name: 'tropical_drink' },
  { alternatives: 'drink alcohol', category: 'objects', name: 'wine_glass' },
  { alternatives: '', category: 'objects', name: 'fork_and_knife' },
  { alternatives: 'food, italian dairy', category: 'objects', name: 'pizza' },
  { alternatives: 'food, american meat', category: 'objects', name: 'hamburger' },
  { alternatives: 'food, american', category: 'objects', name: 'fries' },
  { alternatives: 'food, meat', category: 'objects', name: 'poultry_leg' },
  { alternatives: 'food, meat', category: 'objects', name: 'meat_on_bone' },
  { alternatives: 'food, italian noodles', category: 'objects', name: 'spaghetti' },
  { alternatives: 'food, indian', category: 'objects', name: 'curry' },
  { alternatives: 'food, seafood', category: 'objects', name: 'fried_shrimp' },
  { alternatives: 'food, japanese', category: 'objects', name: 'bento' },
  { alternatives: 'food, japanese', category: 'objects', name: 'sushi' },
  { alternatives: 'food, japanese seafood, naruto', category: 'objects', name: 'fish_cake' },
  { alternatives: 'food', category: 'objects', name: 'rice_ball' },
  { alternatives: 'food', category: 'objects', name: 'rice_cracker' },
  { alternatives: 'food', category: 'objects', name: 'rice' },
  { alternatives: 'food noodles', category: 'objects', name: 'ramen' },
  { alternatives: 'food', category: 'objects', name: 'stew' },
  { alternatives: 'food, japanese', category: 'objects', name: 'oden' },
  { alternatives: 'food, japanese', category: 'objects', name: 'dango' },
  { alternatives: 'food,', category: 'objects', name: 'egg' },
  { alternatives: 'food,', category: 'objects', name: 'bread' },
  { alternatives: 'food, dessert', category: 'objects', name: 'doughnut' },
  { alternatives: 'food, dessert', category: 'objects', name: 'custard' },
  { alternatives: 'food, dessert', category: 'objects', name: 'icecream' },
  { alternatives: 'food, dessert', category: 'objects', name: 'ice_cream' },
  { alternatives: 'food, dessert', category: 'objects', name: 'shaved_ice' },
  { alternatives: '', category: 'objects', name: 'birthday' },
  { alternatives: 'food, dessert', category: 'objects', name: 'cake' },
  { alternatives: 'food, dessert', category: 'objects', name: 'cookie' },
  { alternatives: 'food, dessert', category: 'objects', name: 'chocolate_bar' },
  { alternatives: 'food, dessert', category: 'objects', name: 'candy' },
  { alternatives: 'food, dessert', category: 'objects', name: 'lollipop' },
  { alternatives: 'food, dessert', category: 'objects', name: 'honey_pot' },
  { alternatives: 'food, fruit', category: 'objects', name: 'apple' },
  { alternatives: 'food, fruit', category: 'objects', name: 'green_apple' },
  { alternatives: 'food, fruit', category: 'objects', name: 'tangerine' },
  { alternatives: 'food, fruit', category: 'objects', name: 'lemon' },
  { alternatives: 'food, fruit', category: 'objects', name: 'cherries' },
  { alternatives: 'food, fruit', category: 'objects', name: 'grapes' },
  { alternatives: 'food, fruit', category: 'objects', name: 'watermelon' },
  { alternatives: 'food, fruit', category: 'objects', name: 'strawberry' },
  { alternatives: 'food, fruit', category: 'objects', name: 'peach' },
  { alternatives: 'food, fruit', category: 'objects', name: 'melon' },
  { alternatives: 'food, fruit', category: 'objects', name: 'banana' },
  { alternatives: 'food, fruit', category: 'objects', name: 'pear' },
  { alternatives: 'food, fruit', category: 'objects', name: 'pineapple' },
  { alternatives: 'food, vegetable', category: 'objects', name: 'sweet_potato' },
  { alternatives: 'food, vegetable', category: 'objects', name: 'eggplant' },
  { alternatives: 'food, fruit', category: 'objects', name: 'tomato' },
  { alternatives: 'food, vegetable', category: 'objects', name: 'corn' },

  { alternatives: 'building, home', category: 'places', name: 'house' },
  { alternatives: 'building', category: 'places', name: 'house_with_garden' },
  { alternatives: 'building', category: 'places', name: 'school' },
  { alternatives: 'building, unit', category: 'places', name: 'office' },
  { alternatives: 'building', category: 'places', name: 'post_office' },
  { alternatives: 'building', category: 'places', name: 'hospital' },
  { alternatives: 'building', category: 'places', name: 'bank' },
  { alternatives: 'building', category: 'places', name: 'convenience_store' },
  { alternatives: 'building', category: 'places', name: 'love_hotel' },
  { alternatives: 'building', category: 'places', name: 'hotel' },
  { alternatives: 'building', category: 'places', name: 'wedding' },
  { alternatives: 'building', category: 'places', name: 'church' },
  { alternatives: 'building', category: 'places', name: 'department_store' },
  { alternatives: 'building', category: 'places', name: 'european_post_office' },
  { alternatives: '', category: 'places', name: 'city_sunrise' },
  { alternatives: '', category: 'places', name: 'city_sunset' },
  { alternatives: '', category: 'places', name: 'japanese_castle' },
  { alternatives: '', category: 'places', name: 'european_castle' },
  { alternatives: 'camping', category: 'places', name: 'tent' },
  { alternatives: '', category: 'places', name: 'factory' },
  { alternatives: '', category: 'places', name: 'tokyo_tower' },
  { alternatives: '', category: 'places', name: 'japan' },
  { alternatives: '', category: 'places', name: 'mount_fuji' },
  { alternatives: '', category: 'places', name: 'sunrise_over_mountains' },
  { alternatives: '', category: 'places', name: 'sunrise' },
  { alternatives: '', category: 'places', name: 'stars' },
  { alternatives: '', category: 'places', name: 'statue_of_liberty' },
  { alternatives: '', category: 'places', name: 'bridge_at_night' },
  { alternatives: '', category: 'places', name: 'carousel_horse' },
  { alternatives: '', category: 'places', name: 'rainbow' },
  { alternatives: '', category: 'places', name: 'ferris_wheel' },
  { alternatives: '', category: 'places', name: 'fountain' },
  { alternatives: '', category: 'places', name: 'roller_coaster' },
  { alternatives: 'vehicle', category: 'places', name: 'ship' },
  { alternatives: 'vehicle', category: 'places', name: 'speedboat' },
  { alternatives: 'vehicle', category: 'places', name: 'boat' },
  { alternatives: 'vehicle', category: 'places', name: 'sailboat' },
  { alternatives: 'vehicle', category: 'places', name: 'rowboat' },
  { alternatives: '', category: 'places', name: 'anchor' },
  { alternatives: '', category: 'places', name: 'rocket' },
  { alternatives: 'vehicle', category: 'places', name: 'airplane' },
  { alternatives: 'vehicle', category: 'places', name: 'helicopter' },
  { alternatives: 'vehicle', category: 'places', name: 'steam_locomotive' },
  { alternatives: 'vehicle', category: 'places', name: 'tram' },
  { alternatives: 'vehicle', category: 'places', name: 'mountain_railway' },
  { alternatives: 'vehicle', category: 'places', name: 'bike' },
  { alternatives: 'vehicle', category: 'places', name: 'aerial_tramway' },
  { alternatives: 'vehicle', category: 'places', name: 'suspension_railway' },
  { alternatives: 'vehicle', category: 'places', name: 'mountain_cableway' },
  { alternatives: 'vehicle', category: 'places', name: 'tractor' },
  { alternatives: 'vehicle', category: 'places', name: 'blue_car' },
  { alternatives: 'vehicle', category: 'places', name: 'oncoming_automobile' },
  { alternatives: 'vehicle, car', category: 'places', name: 'car' },
  { alternatives: 'vehicle', category: 'places', name: 'red_car' },
  { alternatives: 'vehicle, car', category: 'places', name: 'taxi' },
  { alternatives: 'vehicle, car', category: 'places', name: 'oncoming_taxi' },
  { alternatives: 'vehicle', category: 'places', name: 'articulated_lorry' },
  { alternatives: 'vehicle', category: 'places', name: 'bus' },
  { alternatives: 'vehicle', category: 'places', name: 'oncoming_bus' },
  { alternatives: '', category: 'places', name: 'rotating_light' },
  { alternatives: 'vehicle', category: 'places', name: 'police_car' },
  { alternatives: 'vehicle', category: 'places', name: 'oncoming_police_car' },
  { alternatives: 'vehicle', category: 'places', name: 'fire_engine' },
  { alternatives: 'vehicle', category: 'places', name: 'ambulance' },
  { alternatives: 'vehicle', category: 'places', name: 'minibus' },
  { alternatives: 'vehicle', category: 'places', name: 'truck' },
  { alternatives: 'vehicle', category: 'places', name: 'train' },
  { alternatives: '', category: 'places', name: 'station' },
  { alternatives: 'vehicle', category: 'places', name: 'train2' },
  { alternatives: 'vehicle', category: 'places', name: 'bullettrain_front' },
  { alternatives: 'vehicle', category: 'places', name: 'bullettrain_side' },
  { alternatives: 'vehicle', category: 'places', name: 'light_rail' },
  { alternatives: 'vehicle', category: 'places', name: 'monorail' },
  { alternatives: 'vehicle', category: 'places', name: 'railway_car' },
  { alternatives: 'vehicle', category: 'places', name: 'trolleybus' },
  { alternatives: '', category: 'places', name: 'ticket' },
  { alternatives: '', category: 'places', name: 'fuelpump' },
  { alternatives: '', category: 'places', name: 'vertical_traffic_light' },
  { alternatives: 'stoplight', category: 'places', name: 'traffic_light' },
  { alternatives: '', category: 'places', name: 'warning' },
  { alternatives: '', category: 'places', name: 'construction' },
  { alternatives: '', category: 'places', name: 'beginner' },
  { alternatives: '', category: 'places', name: 'atm' },
  { alternatives: '', category: 'places', name: 'slot_machine' },
  { alternatives: '', category: 'places', name: 'busstop' },
  { alternatives: '', category: 'places', name: 'barber' },
  { alternatives: '', category: 'places', name: 'hotsprings' },
  { alternatives: '', category: 'places', name: 'checkered_flag' },
  { alternatives: '', category: 'places', name: 'crossed_flags' },
  { alternatives: '', category: 'places', name: 'izakaya_lantern' },
  { alternatives: '', category: 'places', name: 'moyai' },
  { alternatives: '', category: 'places', name: 'circus_tent' },
  { alternatives: '', category: 'places', name: 'performing_arts' },
  { alternatives: '', category: 'places', name: 'round_pushpin' },
  { alternatives: '', category: 'places', name: 'triangular_flag_on_post' },
  { alternatives: 'japan, nippon, nihon', category: 'places', name: 'jp' },
  { alternatives: 'korea, hanguk', category: 'places', name: 'kr' },
  { alternatives: 'china, prc', category: 'places', name: 'cn' },
  { alternatives: 'usa, america, united states', category: 'places', name: 'us' },
  { alternatives: 'france', category: 'places', name: 'fr' },
  { alternatives: 'spain, espana', category: 'places', name: 'es' },
  { alternatives: 'italy, italia', category: 'places', name: 'it' },
  { alternatives: 'russia', category: 'places', name: 'ru' },
  { alternatives: 'great britain, united kingdom', category: 'places', name: 'gb' },
  { alternatives: 'great britain, united kingdom', category: 'places', name: 'uk' },
  { alternatives: 'germany, deutschland', category: 'places', name: 'de' },

  { alternatives: '10', category: 'symbols', name: 'keycap_ten' },
  { alternatives: '', category: 'symbols', name: '1234' },
  { alternatives: '', category: 'symbols', name: 'symbols' },
  { alternatives: 'left', category: 'symbols', name: 'arrow_backward' },
  { alternatives: '', category: 'symbols', name: 'arrow_down' },
  { alternatives: 'right', category: 'symbols', name: 'arrow_forward' },
  { alternatives: '', category: 'symbols', name: 'arrow_left' },
  { alternatives: '', category: 'symbols', name: 'capital_abcd' },
  { alternatives: '', category: 'symbols', name: 'abcd' },
  { alternatives: '', category: 'symbols', name: 'abc' },
  { alternatives: '', category: 'symbols', name: 'arrow_lower_left' },
  { alternatives: '', category: 'symbols', name: 'arrow_lower_right' },
  { alternatives: '', category: 'symbols', name: 'arrow_right' },
  { alternatives: '', category: 'symbols', name: 'arrow_up' },
  { alternatives: '', category: 'symbols', name: 'arrow_upper_left' },
  { alternatives: '', category: 'symbols', name: 'arrow_upper_right' },
  { alternatives: '', category: 'symbols', name: 'arrow_double_down' },
  { alternatives: '', category: 'symbols', name: 'arrow_double_up' },
  { alternatives: '', category: 'symbols', name: 'arrow_down_small' },
  { alternatives: '', category: 'symbols', name: 'arrow_heading_down' },
  { alternatives: '', category: 'symbols', name: 'arrow_heading_up' },
  { alternatives: '', category: 'symbols', name: 'leftwards_arrow_with_hook' },
  { alternatives: '', category: 'symbols', name: 'arrow_right_hook' },
  { alternatives: '', category: 'symbols', name: 'left_right_arrow' },
  { alternatives: '', category: 'symbols', name: 'arrow_up_down' },
  { alternatives: '', category: 'symbols', name: 'arrow_up_small' },
  { alternatives: '', category: 'symbols', name: 'arrows_clockwise' },
  { alternatives: '', category: 'symbols', name: 'arrows_counterclockwise' },
  { alternatives: '', category: 'symbols', name: 'rewind' },
  { alternatives: '', category: 'symbols', name: 'fast_forward' },
  { alternatives: '', category: 'symbols', name: 'information_source' },
  { alternatives: '', category: 'symbols', name: 'ok' },
  { alternatives: '', category: 'symbols', name: 'twisted_rightwards_arrows' },
  { alternatives: '', category: 'symbols', name: 'repeat' },
  { alternatives: '', category: 'symbols', name: 'repeat_one' },
  { alternatives: '', category: 'symbols', name: 'new' },
  { alternatives: '', category: 'symbols', name: 'top' },
  { alternatives: '', category: 'symbols', name: 'up' },
  { alternatives: '', category: 'symbols', name: 'cool' },
  { alternatives: '', category: 'symbols', name: 'free' },
  { alternatives: '', category: 'symbols', name: 'ng' },
  { alternatives: 'movie', category: 'symbols', name: 'cinema' },
  { alternatives: '', category: 'symbols', name: 'koko' },
  { alternatives: '', category: 'symbols', name: 'signal_strength' },
  { alternatives: 'wari', category: 'symbols', name: 'u5272' },
  { alternatives: '', category: 'symbols', name: 'u5408' },
  { alternatives: 'ying', category: 'symbols', name: 'u55b6' },
  { alternatives: 'zhǐ, zhi', category: 'symbols', name: 'u6307' },
  { alternatives: 'yuè, yue', category: 'symbols', name: 'u6708' },
  { alternatives: 'yǒu, you', category: 'symbols', name: 'u6709' },
  { alternatives: 'mitsuru', category: 'symbols', name: 'u6e80' },
  { alternatives: 'wú, wu', category: 'symbols', name: 'u7121' },
  { alternatives: 'shēn, shen', category: 'symbols', name: 'u7533' },
  { alternatives: 'kōng, kong', category: 'symbols', name: 'u7a7a' },
  { alternatives: 'jìn, jin', category: 'symbols', name: 'u7981' },
  { alternatives: '', category: 'symbols', name: 'sa' },
  { alternatives: '', category: 'symbols', name: 'restroom' },
  { alternatives: '', category: 'symbols', name: 'mens' },
  { alternatives: '', category: 'symbols', name: 'womens' },
  { alternatives: '', category: 'symbols', name: 'baby_symbol' },
  { alternatives: '', category: 'symbols', name: 'no_smoking' },
  { alternatives: '', category: 'symbols', name: 'parking' },
  { alternatives: '', category: 'symbols', name: 'wheelchair' },
  { alternatives: '', category: 'symbols', name: 'metro' },
  { alternatives: '', category: 'symbols', name: 'baggage_claim' },
  { alternatives: '', category: 'symbols', name: 'accept' },
  { alternatives: '', category: 'symbols', name: 'wc' },
  { alternatives: '', category: 'symbols', name: 'potable_water' },
  { alternatives: '', category: 'symbols', name: 'put_litter_in_its_place' },
  { alternatives: '', category: 'symbols', name: 'secret' },
  { alternatives: '', category: 'symbols', name: 'congratulations' },
  { alternatives: '', category: 'symbols', name: 'm' },
  { alternatives: '', category: 'symbols', name: 'passport_control' },
  { alternatives: '', category: 'symbols', name: 'left_luggage' },
  { alternatives: '', category: 'symbols', name: 'customs' },
  { alternatives: '', category: 'symbols', name: 'ideograph_advantage' },
  { alternatives: '', category: 'symbols', name: 'cl' },
  { alternatives: '', category: 'symbols', name: 'sos' },
  { alternatives: '', category: 'symbols', name: 'id' },
  { alternatives: '', category: 'symbols', name: 'no_entry_sign' },
  { alternatives: '', category: 'symbols', name: 'underage' },
  { alternatives: '', category: 'symbols', name: 'no_mobile_phones' },
  { alternatives: '', category: 'symbols', name: 'do_not_litter' },
  { alternatives: '', category: 'symbols', name: 'non-potable_water' },
  { alternatives: '', category: 'symbols', name: 'no_bicycles' },
  { alternatives: '', category: 'symbols', name: 'no_pedestrians' },
  { alternatives: '', category: 'symbols', name: 'children_crossing' },
  { alternatives: '', category: 'symbols', name: 'no_entry' },
  { alternatives: '', category: 'symbols', name: 'eight_spoked_asterisk' },
  { alternatives: '', category: 'symbols', name: 'sparkle' },
  { alternatives: '', category: 'symbols', name: 'eight_pointed_black_star' },
  { alternatives: '', category: 'symbols', name: 'heart_decoration' },
  { alternatives: '', category: 'symbols', name: 'vs' },
  { alternatives: '', category: 'symbols', name: 'vibration_mode' },
  { alternatives: '', category: 'symbols', name: 'mobile_phone_off' },
  { alternatives: 'yen', category: 'symbols', name: 'chart' },
  { alternatives: '', category: 'symbols', name: 'currency_exchange' },
  { alternatives: 'zodiac', category: 'symbols', name: 'aries' },
  { alternatives: 'zodiac', category: 'symbols', name: 'taurus' },
  { alternatives: 'zodiac', category: 'symbols', name: 'gemini' },
  { alternatives: 'zodiac', category: 'symbols', name: 'cancer' },
  { alternatives: 'zodiac', category: 'symbols', name: 'leo' },
  { alternatives: 'zodiac', category: 'symbols', name: 'virgo' },
  { alternatives: 'zodiac', category: 'symbols', name: 'libra' },
  { alternatives: 'zodiac', category: 'symbols', name: 'scorpius' },
  { alternatives: 'zodiac', category: 'symbols', name: 'sagittarius' },
  { alternatives: 'zodiac', category: 'symbols', name: 'capricorn' },
  { alternatives: 'zodiac', category: 'symbols', name: 'aquarius' },
  { alternatives: 'zodiac', category: 'symbols', name: 'pisces' },
  { alternatives: 'zodiac', category: 'symbols', name: 'ophiuchus' },
  { alternatives: '', category: 'symbols', name: 'six_pointed_star' },
  { alternatives: '', category: 'symbols', name: 'negative_squared_cross_mark' },
  { alternatives: '', category: 'symbols', name: 'a' },
  { alternatives: '', category: 'symbols', name: 'b' },
  { alternatives: '', category: 'symbols', name: 'ab' },
  { alternatives: '', category: 'symbols', name: 'o2' },
  { alternatives: '', category: 'symbols', name: 'diamond_shape_with_a_dot_inside' },
  { alternatives: '', category: 'symbols', name: 'recycle' },
  { alternatives: '', category: 'symbols', name: 'end' },
  { alternatives: '', category: 'symbols', name: 'back' },
  { alternatives: '', category: 'symbols', name: 'on' },
  { alternatives: '', category: 'symbols', name: 'soon' },
  { alternatives: 'time', category: 'symbols', name: 'clock1' },
  { alternatives: 'time', category: 'symbols', name: 'clock130' },
  { alternatives: 'time', category: 'symbols', name: 'clock10' },
  { alternatives: 'time', category: 'symbols', name: 'clock1030' },
  { alternatives: 'time', category: 'symbols', name: 'clock11' },
  { alternatives: 'time', category: 'symbols', name: 'clock1130' },
  { alternatives: 'midnight, noon, time', category: 'symbols', name: 'clock12' },
  { alternatives: 'time', category: 'symbols', name: 'clock1230' },
  { alternatives: 'time', category: 'symbols', name: 'clock2' },
  { alternatives: 'time', category: 'symbols', name: 'clock230' },
  { alternatives: 'time', category: 'symbols', name: 'clock3' },
  { alternatives: 'time', category: 'symbols', name: 'clock330' },
  { alternatives: 'time', category: 'symbols', name: 'clock4' },
  { alternatives: 'time', category: 'symbols', name: 'clock430' },
  { alternatives: 'time', category: 'symbols', name: 'clock5' },
  { alternatives: 'time', category: 'symbols', name: 'clock530' },
  { alternatives: 'time', category: 'symbols', name: 'clock6' },
  { alternatives: 'time', category: 'symbols', name: 'clock630' },
  { alternatives: 'time', category: 'symbols', name: 'clock7' },
  { alternatives: 'time', category: 'symbols', name: 'clock730' },
  { alternatives: 'time', category: 'symbols', name: 'clock8' },
  { alternatives: 'time', category: 'symbols', name: 'clock830' },
  { alternatives: 'time', category: 'symbols', name: 'clock9' },
  { alternatives: 'time', category: 'symbols', name: 'clock930' },
  { alternatives: '', category: 'symbols', name: 'heavy_dollar_sign' },
  { alternatives: '', category: 'symbols', name: 'tm' },
  { alternatives: '', category: 'symbols', name: 'x' },
  { alternatives: '', category: 'symbols', name: 'heavy_exclamation_mark' },
  { alternatives: '', category: 'symbols', name: 'bangbang' },
  { alternatives: '', category: 'symbols', name: 'interrobang' },
  { alternatives: '', category: 'symbols', name: 'o' },
  { alternatives: '', category: 'symbols', name: 'heavy_multiplication_x' },
  { alternatives: '', category: 'symbols', name: 'heavy_plus_sign' },
  { alternatives: '', category: 'symbols', name: 'heavy_minus_sign' },
  { alternatives: '', category: 'symbols', name: 'heavy_division_sign' },
  { alternatives: 'floral', category: 'symbols', name: 'white_flower' },
  { alternatives: '', category: 'symbols', name: '100' },
  { alternatives: '', category: 'symbols', name: 'heavy_check_mark' },
  { alternatives: '', category: 'symbols', name: 'ballot_box_with_check' },
  { alternatives: '', category: 'symbols', name: 'radio_button' },
  { alternatives: '', category: 'symbols', name: 'link' },
  { alternatives: '', category: 'symbols', name: 'curly_loop' },
  { alternatives: '', category: 'symbols', name: 'wavy_dash' },
  { alternatives: '', category: 'symbols', name: 'part_alternation_mark' },
  { alternatives: '', category: 'symbols', name: 'trident' },
  { alternatives: '', category: 'symbols', name: 'black_small_square' },
  { alternatives: '', category: 'symbols', name: 'white_small_square' },
  { alternatives: '', category: 'symbols', name: 'black_medium_small_square' },
  { alternatives: '', category: 'symbols', name: 'white_medium_small_square' },
  { alternatives: '', category: 'symbols', name: 'black_medium_square' },
  { alternatives: '', category: 'symbols', name: 'white_medium_square' },
  { alternatives: '', category: 'symbols', name: 'black_large_square' },
  { alternatives: '', category: 'symbols', name: 'white_large_square' },
  { alternatives: '', category: 'symbols', name: 'white_check_mark' },
  { alternatives: '', category: 'symbols', name: 'black_square_button' },
  { alternatives: '', category: 'symbols', name: 'white_square_button' },
  { alternatives: '', category: 'symbols', name: 'black_circle' },
  { alternatives: '', category: 'symbols', name: 'white_circle' },
  { alternatives: '', category: 'symbols', name: 'red_circle' },
  { alternatives: '', category: 'symbols', name: 'large_blue_circle' },
  { alternatives: '', category: 'symbols', name: 'large_blue_diamond' },
  { alternatives: '', category: 'symbols', name: 'large_orange_diamond' },
  { alternatives: '', category: 'symbols', name: 'small_blue_diamond' },
  { alternatives: '', category: 'symbols', name: 'small_orange_diamond' },
  { alternatives: '', category: 'symbols', name: 'small_red_triangle' },
  { alternatives: '', category: 'symbols', name: 'small_red_triangle_down' },
];
